import React from "react"
import { Link } from "gatsby"
import priceBox from "./pricebox.module.scss"
import FeatherIcon from "feather-icons-react"

export default function pricebox(props) {
  return (
    <div className={`${priceBox.parent} parent `}>
      <div className={priceBox.layout}>
        <div className={priceBox.boxLeft}>
          <div className={priceBox.iconContainer}>
            <FeatherIcon icon={props.feather} />
          </div>
          <p className={priceBox.title}>{props.title}</p>
          <p className={priceBox.text}>{props.text}</p>
        </div>
        <div className={priceBox.boxRight}>
          {props.monthly ? (
            <div className={priceBox.priceContainer}>
              <p className={priceBox.priceTag}>{props.monthly}</p>
              <p className={priceBox.priceTagInfo}> per. month </p>
            </div>
          ) : (
            ""
          )}
          {props.monthly && props.yearly ? (
            <p className={priceBox.text}> OR </p>
          ) : (
            ""
          )}
          {props.yearly ? (
            <div className={priceBox.priceContainer}>
              <p className={priceBox.priceTag}>{props.yearly}</p>
              <p className={priceBox.priceTagInfo}> per. year </p>
            </div>
          ) : (
            ""
          )}
          <div className={priceBox.contact}>
            {props.contact ? <Link to="/contact/"> Contact us </Link> : ""}
          </div>
        </div>
      </div>
    </div>
  )
}
